// const baseURL = 'http://keaa.o2oz.net';
// const baseURL = 'https://www.eaa.or.kr';

// 로컬 개발: localhost일 때 nginx 8095 포트 로컬 API 사용
const baseURL =
  ( window.location.host.indexOf('localhost') > -1 )
  ? 'http://localhost:8095'
  : ( window.location.host.indexOf('192.168.') > -1 ) ? 'http://localhost:8095' : window.location.origin;
// const baseURL = window.location.origin;

export const config = {
  production: false,
  baseUrl: baseURL,
  apiBaseUrl: baseURL + "/api",
  apiFileUploadUrl: baseURL + "/api/file/file_upload.php",
  apiInspectionUploadUrl: baseURL + "/api/file/file_upload_inspection.php",
  apiImageUploadUrl: baseURL + "/api/file/image_upload.php",
  cookie_token: 'keaatoken',
  cookie_id: 'keaaid',
};
